module.exports = __webpack_public_path__ + "static/media/folder.7151fed0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Teams/Listing/img/folder.svg
// module id = 283
// module chunks = 0